import { render, staticRenderFns } from "./banned.vue?vue&type=template&id=ea04e1ac&"
import script from "./banned.vue?vue&type=script&lang=js&"
export * from "./banned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea04e1ac')) {
      api.createRecord('ea04e1ac', component.options)
    } else {
      api.reload('ea04e1ac', component.options)
    }
    module.hot.accept("./banned.vue?vue&type=template&id=ea04e1ac&", function () {
      api.rerender('ea04e1ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/banned.vue"
export default component.exports